import { changePassword } from "@shared/actions/user";
import { Button, Spinner } from "@shared/components";
import { MIN_PASS_CHARS } from "@shared/constants/app";
import { useUserState } from "@shared/hooks/user";
import cx from "classnames";
import React, { memo } from "react";
import { useIntl } from "react-intl";
import { useDispatch } from "react-redux";
import { Field, reduxForm, SubmissionError } from "redux-form";

const renderField = (values) => {
  const {
    input,
    label,
    type,
    placeholder,
    meta: { touched, error },
  } = values;
  const formErrorStyle = cx({ form__item_error: !!(touched && error) });
  return (
    <div className={`grid__item_12 form__item ${formErrorStyle}`}>
      <div className="grid__item_4">
        <label className="form__label form__label">{label}</label>
      </div>
      <div className="grid__item_4">
        <input
          {...input}
          type={type}
          className="form__input"
          placeholder={placeholder}
        />
        {touched && error && <div className="form__message">{error}</div>}
      </div>
    </div>
  );
};

const FormView = memo(({ handleSubmit }) => {
  const intl = useIntl();
  const userState = useUserState();
  const { loading, success } = userState;
  const dispatch = useDispatch();
  const validateAuth = (values) => {
    const { oldPassword, newPassword } = values;
    if (newPassword?.length < MIN_PASS_CHARS) {
      throw new SubmissionError({
        newPassword: intl.formatMessage({
          id: "boilerplate.components.ModalRoom.PasswordFillError",
        }),
      });
    }

    dispatch(changePassword({ oldPassword, newPassword }));
  };

  let BottomView = (
    <div className="grid__item_7">
      <Button variant="primary" type="submit" tagName="button">
        {intl.formatMessage({
          id: "boilerplate.components.ModalRoom.Settings.PasswordUpdateButton",
        })}
      </Button>
    </div>
  );

  if (loading) {
    BottomView = <Spinner />;
  } else if (success) {
    BottomView = (
      <div className="msg msg_success">
        {intl.formatMessage({
          id: "boilerplate.components.ModalRoom.Settings.PasswordUpdateDone",
        })}
      </div>
    );
  }

  return (
    <form
      className="form form_horizontal grid"
      onSubmit={handleSubmit(validateAuth)}
    >
      <div className="form__step">
        <Field
          type="password"
          name="oldPassword"
          component={renderField}
          label={intl.formatMessage({
            id: "boilerplate.components.ModalRoom.Settings.OldPassword",
          })}
        />
        <Field
          type="password"
          name="newPassword"
          component={renderField}
          label={intl.formatMessage({
            id: "boilerplate.components.ModalRoom.Settings.NewPassword",
          })}
        />

        <div className="form__item form__item_divide grid__item_12 grid__item_center">
          <div className="grid__item_4 grid__item_null grid__item_end">
            {BottomView}
          </div>
        </div>
      </div>
    </form>
  );
});

FormView.displayName = "PasswordsDataFormView";

export const PasswordsDataFormView = reduxForm({
  form: "ChangePasswordForm",
})(FormView);
